import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { ContentContainer } from '@atlassian/amkt-common';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../constants/proptypes/CommonPropTypes";
import { validateFilters } from "../../utils/filters";

var FiltersValidationContainer = /*#__PURE__*/function (_Component) {
  _inherits(FiltersValidationContainer, _Component);

  var _super = _createSuper(FiltersValidationContainer);

  function FiltersValidationContainer() {
    _classCallCheck(this, FiltersValidationContainer);

    return _super.apply(this, arguments);
  }

  _createClass(FiltersValidationContainer, [{
    key: "render",
    value: function render() {
      var validationErrs = validateFilters(this.props.filters);
      return /*#__PURE__*/React.createElement(ContentContainer, {
        baseMessage: "Oops! The filters you provided are invalid.",
        dataError: validationErrs.size > 0,
        dataErrorMessages: validationErrs.map(function (err) {
          return Immutable.Map({
            message: err
          });
        }).toList(),
        loading: false
      }, this.props.children);
    }
  }]);

  return FiltersValidationContainer;
}(Component);

_defineProperty(FiltersValidationContainer, "propTypes", {
  children: PropTypes.node,
  filters: CommonPropTypes.filters.isRequired
});

export { FiltersValidationContainer as default };